// deprecated, @TODO: remove and test
window.products = function productSearch() {
    return {
        id: "992",
        product: null,
        isLoading: false,
        fetchProducts() {
            console.log(this.id);
            this.isLoading = true;
            fetch(`/ajax/api/products.json?id=${this.id}`)
                .then((res) => res.json())
                .then((data) => {
                    this.isLoading = false;
                    this.product = data;
                });
        },
    };
};
